







































































import Vue, { VueConstructor } from 'vue'
import BalanceCard from '@/components/BalanceCard.vue'
import ReimbursementsList from '@/components/ReimbursementsList.vue'
import Organization from '../../../../../store/models/Organization'
import AccountMixin from '../../../../../mixins/accountMixin'
import api from '@/api'

interface Refund {
  transactionNumber: number
  sfd: string
  creditLine: string
  initiatorName: string
  dateTime: string
  amount: number
  mobileOperator: string
}

interface ComponentData {
  items: Refund[]
  columns: Record<string, string | boolean>[]
  deadlines: any[]
}

export default (Vue as VueConstructor<
  Vue & InstanceType<typeof AccountMixin>
>).extend({
  components: {
    BalanceCard,
    ReimbursementsList
  },

  data(): ComponentData {
    return {
      items: [],
      deadlines: [],
      columns: [
        {
          label: 'N° Transaction',
          field: 'refundTransaction.reference'
        },
        {
          label: 'SFD',
          field: 'organization.name',
          searchable: true
        },
        {
          label: 'Ligne de crédit',
          field: 'creditLine.name',
          searchable: true
        },
        {
          label: 'Date/Heure',
          field: 'updatedAt'
        },
        {
          label: 'Montant',
          field: 'amount'
        },
        {
          label: 'Opérateur Mobile',
          field: 'otm',
          align: 'center',
          searchable: true
        },
        {
          label: 'Actions',
          field: '_actions',
          align: 'right'
        }
      ]
    }
  },

  mixins: [AccountMixin],

  computed: {
    organization(): Organization {
      return Organization.loggedIn()
    },

    moovBalance(this: any): number {
      return this.soldeRembourssementMoov
    },
    mtnBalance(this: any): number {
      return this.soldeRembourssementMtn
    },
    totalBalance(this: any): number {
      return this.moovBalance + this.mtnBalance
    }
  },

  async created(this: any) {
    try {
      const { data } = await api.get('/credit-line-deadlines', {
        params: {
          productId: this.getCurrentProduct.id,
          populate: 'organization,refundTransaction,creditLine'
        }
      })
      this.deadlines = data.result
    } catch (error) {
      this.$notify.error(
        'Une erreur est survenue lors du chargement des remboursements'
      )
    }
  },

  methods: {
    onSeeDetails() {
      // this.$router.push({ name: 'refunds.details', params: { refundId: id } })
    }
  }
})
